<template>
  <li class="dropdown notifications-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
      <i class="fa fa-server"></i>
      <span
        class="label"
        :class="{ 'label-warning': loading, 'label-success': !loading }"
        v-if="queue.length"
      >
        <i class="fa fa-spinner faa-spin animated" v-if="loading"></i>
        <span v-if="!loading">{{ queue.length }}</span>
      </span>
    </a>
    <ul class="dropdown-menu">
      <li class="header" v-if="!queue.length">Não há nada na fila!</li>
      <li>
        <ul class="menu">
          <li v-for="(item, idx) in queue" :key="idx">
            <a href="#" class="quebra" @click.prevent="execCallback(item, idx)">
              <h4>
                {{ item.description }}
                <p class="pull-right">
                  <i class="fa fa-spinner faa-spin animated" v-if="item.status === 'PENDING'"></i>
                  <i
                    :class="{
                      'fa fa-clock-o': item.status === 'AWAITING',
                      'fa fa-check text-success': item.status === 'SUCCESS',
                      'fa fa-exclamation text-danger': item.status === 'ERROR'
                    }"
                    aria-hidden="true"
                  ></i>
                </p>
              </h4>
              <div class="progress sm">
                <div
                  class="progress-bar progress-bar-success"
                  :class="{
                    'progress-bar-striped active progress-bar-info': item.status === 'PENDING',
                    'progress-bar-danger': item.status === 'ERROR',
                    'progress-bar-warning': item.status === 'AWAITING'
                  }"
                  style="width: 100%"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <span class="sr-only">20% Complete</span>
                </div>
              </div>
              <p v-if="item.status === 'AWAITING'">Aguardando Fila</p>
            </a>
          </li>
        </ul>
      </li>
      <!-- <li class="footer"><a href="#">View all</a></li> -->
    </ul>
  </li>
</template>

<script>
import Clipboard from 'clipboard'

export default {
  name: 'TheQueue',
  data() {
    return {}
  },
  mounted() {},
  methods: {
    execCallback(item, idx) {
      if (item.status === 'SUCCESS') {
        item.callbackFn(item.response, ...item.callbackParams)
        this.$store.dispatch('removeFromQueue', idx)
      }

      if (item.status === 'ERROR') {
        const elm = document.createElement('button')
        elm.setAttribute('hidden', 'hidden')
        elm.setAttribute(
          'data-clipboard-text',
          item.response.data ? item.response.data.message : 'Não foi possível capturar o erro :('
        )
        const clipboard = new Clipboard(elm)
        elm.click()
        this.$messages.info().toast('A mensagem de erro foi copiada para a área de tranferência.')
        clipboard.listener.destroy()
        this.$store.dispatch('removeFromQueue', idx)
      }
    }
  },
  computed: {
    queue() {
      return this.$store.getters.getQueue
    },

    loading() {
      return this.queue.some(x => x.status === 'PENDING')
    }
  }
}
</script>

<style></style>
